import React from 'react';
import { TextField } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../../app/hooks';
import { updateTicketTimeTracking } from '../../../../state';
import { toLocalDateTimeString, fromLocalDateTimeString } from '../../../../../../utils/DateConversions';

const UpdatedDateEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentTicket } = useAppSelector(state => state.ticket);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateTicketTimeTracking({ updatedDate: fromLocalDateTimeString(event.target.value) }));
  };

  return (
    <TextField
      label="Updated Date"
      size="small"
      type="datetime-local"
      fullWidth
      value={currentTicket?.timeTracking.updatedDate ? toLocalDateTimeString(currentTicket.timeTracking.updatedDate) : ''}
      onChange={handleChange}
      InputLabelProps={{ shrink: true }}
      disabled // Usually auto-set
    />
  );
};

export default UpdatedDateEdit;
